import { FileDto } from "./file.dto"

import * as _ from 'lodash'

import { PagingDto } from "./paging.dto"
import { CategoryDto } from "./category.dto"
import { flattenAttributes, ProductOptionValue } from "../../+merchant/+product/edit-product/edit-product.utils"
import { TranslationDto } from "./translation.dto"
import { ChoiceGroupDto } from "./choice-group.dto"
import { BadgeType } from "../../../app/+merchant/+product/edit-product/edit-product.constants"
import { ProductDiscountItemDto } from "./product-discount.dto"

export class ProductDto {
  id: string
  sku: string
  name: TranslationDto
  salePrice: number
  enabled: boolean
  adminEnabled: boolean
  stockQuantity: number
  thumbnail?: FileDto
  colorThumbnail?: FileDto
  productAttributes: any
  published: boolean
  allowSelection: boolean
  lowStockAlertQuantity?: number
  specifications?: any
  price: number
  tenant: any
  type: string
  stock: string
  rating: number
  numberOfReviews: number
  weightKg: number
  badgeType?: string

  static create(attributes: any) {
    return _.assign<ProductDto>({
      id: null,
      sku: null,
      name: TranslationDto.create(),
      salePrice: 0,
      stockQuantity: 0,
      lowStockAlertQuantity: 0,
      enabled: true,
      adminEnabled: true,
      thumbnail: null,
      colorThumbnail: null,
      productAttributes: attributes,
      published: false,
      weightKg: null,
      badgeType: null,
      allowSelection: false,
      specifications: []
    })
  }
}

export class FindProductDto extends PagingDto {
  public searchText?: string
  public enabled?: string
  public adminEnabled?: boolean
  public categoryId? : string
  public sort?: string
  public tenantId?: string
  public discounted?: string
  public badgeType?: string
}

export class FindProductDefaultDto extends PagingDto {
  public searchText?: string
}

export class FindProductsAllReview extends PagingDto {
  public searchText?: string
  public categoryId? : string
  public sort?: string
  public tenantId?: string
  public discounted?: string
}

export class ExportProductDto {
  enabled?: string
  tenantId?: string
}

export class ProductDetailDto extends ProductDto {
  options: object[]
  description?: TranslationDto
  images: FileDto[]
  video: FileDto
  specsImages: FileDto[]
  children: ProductDto[]
  category: CategoryDto
  specifications?: any
  type: string
  weightKg: number
  brandId: string
  badgeType: BadgeType

  static create(attributes: any = null) {
    return _.assign<ProductDetailDto>({
      id: null,
      sku: null,
      parentId: null,
      name: TranslationDto.create(),
      description: TranslationDto.create(),
      salePrice: 0,
      price: 0,
      discount: 0,
      discountType: 'percentage',
      stockQuantity: 0,
      lowStockAlertQuantity: 0,
      enabled: true,
      adminEnabled: true,
      thumbnail: null,
      productAttributes: attributes,
      options: [],
      type: 'stockable',
      stock: 'in-stock',
      images: [],
      specsImages: [],
      video: null,
      children: [],
      category: null,
      published: false,
      allowSelection: false,
      specifications: [],
      weightKg: 0,
      badgeType: null,
      brandId: ''
    })
  }
}

export class CreateOrUpdateProductDto {
  id?: string
  categoryId?: string
  parentId?: string
  thumbnailId?: string
  sku?: string
  name: _.Dictionary<string>
  type: string
  stock: string
  condition?: string
  specification?: string
  salePrice: number
  allowSelection: boolean
  stockQuantity: number
  productAttributes?: any
  options?: any
  discountType?: string
  discount?: number
  description?: _.Dictionary<string>
  lowStockAlertQuantity?: number
  published?: boolean
  brandId?: string
  videoId?: string
  badgeType?: string

  static create(data: ProductDto) {
    return _.assign(data)
  }
}

export class CreateOrUpdateProductV2Dto {
  thumbnailId?: string
  name: _.Dictionary<string>
  description?: _.Dictionary<string>
  lowStockAlertQuantity?: number
  published?: boolean
  videoId?: string
  badgeType?: string

  static create(data: ProductDto) {
    return _.assign(data)
  }
}

export class CreateProductDto {
  product: ProductDto
  attributes: _.Dictionary<ProductOptionValue>

  static create(data: ProductDto, attributes: _.Dictionary<ProductOptionValue>) {
    const productAttributes = flattenAttributes(attributes)
    const flattenedAttributes = { productAttributes }

    return _.assign(data, flattenedAttributes)
  }
}

export class ProductDiscountItemsDto {
  product: ProductDiscountItemDto
  discountPercent: number
  exclude: boolean

  static create(data?: ProductDiscountItemsDto) {
    return _.assign<ProductDiscountItemsDto>({
      product: data?.product ?? null,
      discountPercent: data?.discountPercent ?? null,
      exclude: data?.exclude ?? false
    })
  }
}


export class CreateProductDiscountItemsDto {
  productId: ProductDto
  discountPercent: number
  exclude: boolean

  static create(data: ProductDiscountItemsDto) {
    return _.assign<ProductDiscountItemsDto>({
      productId: data.product.id,
      discountPercent: data.discountPercent ?? null,
      exclude: data?.exclude ?? false
    })
  }
}
